/**
 * Like
 */
import Like from './Like';
import Util from '../../Util';
import Config from '../../Config';

class SandboxLike extends Like {

	private host: string;

	private likeInfoAPI: string;

	private likeAPI: string;

	private unLikeAPI: string;

	private extPostTxtId: string;

	private voteSelector: string;

	private isLiked: boolean;

	constructor( $parent: any, board: any, articleId: any ) {
		super( $parent );

		if ( board === 'news' ) {
			return;
		}

		if ( board.indexOf( 'library' ) !== -1 ) {
			board = 'library';
		}

		this.host = 'http://api.sandbox.plaync.com';

		if ( /^(rc\.|rc-)/.test( location.hostname ) ) {
			this.host = 'http://rc.api.sandbox.plaync.com';
		}

		this.likeInfoAPI = `${this.host}/timeline/like/info.jsonp`;
		this.likeAPI = `${this.host}/timeline/like/like.jsonp`;
		this.unLikeAPI = `${this.host}/timeline/like/cancel.jsonp`;
		this.extPostTxtId = `BNS:${board}:${articleId}`;
		this.isLiked = false;
		this.voteSelector = `.board-view .co-btn-like`;

		$parent.append( this.template() );
		this.addEvent();
		this.info();
	}

	public template() {
		return `<button class="co-btn co-btn-like" data-extPostTxtId="${this.extPostTxtId}">
			<i class="fe-icon-vote-like"></i>
			<em>0</em>
		</button>`;
	}

	public setCount( count: string|number ) {
		jQuery( `${this.voteSelector} em` ).text( count );
	}

	public like() {
		const _promise = Util.getJsonp( this.likeAPI, 'GET', {
			extPostTxtId: this.extPostTxtId,
		});
		_promise.then( ( data: any ) => {

			if ( data && data.result && data.result.code && data.result.code.toString() === '101' ) {
				Config.apiError( data.result.code );
				return;
			}

			this.isLiked = true;
			this.info();
		}, () => {
			// reject
		});
	}

	public unLike() {
		const _promise = Util.getJsonp( this.unLikeAPI, 'GET', {
			extPostTxtId: this.extPostTxtId,
		});
		_promise.then( ( data: any ) => {
			this.isLiked = false;
			this.info();
		}, () => {
			// reject
		});
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', `${this.voteSelector}`, ( evt ) => {
			( this.isLiked ) ?
				this.unLike() :
				this.like();
		});
	}

	private info() {
		const _promise = Util.getJsonp( this.likeInfoAPI, 'GET', {
			extPostTxtId: this.extPostTxtId,
		});
		_promise.then( ( data: any ) => {
			data = data.data;

			if ( data && data.code && data.code.toString() === '101' ) {
				Config.apiError( data.code );
				return;
			}

			this.isLiked = data.liked;
			this.setCount( data.count );

			( this.isLiked ) ?
				jQuery( this.voteSelector ).addClass( 'is-active' ) :
				jQuery( this.voteSelector ).removeClass( 'is-active' );
		}, () => {
			// reject
		});
	}
}

export default SandboxLike;
